import "react";
import { styled as e } from "styled-components";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/Primitives/CellMain.tsx
var r = e.div`
    display: flex;
    flex-direction: ${({ $orientation: e }) => e === "vertical" ? "column" : "row"};
    align-items: ${({ $orientation: e, $hasSecondaryText: t }) => e === "vertical" ? "center" : t ? "flex-start" : "center"};
    text-align: ${({ $orientation: e }) => e === "vertical" ? "center" : "left"};
    gap: ${({ theme: e }) => e.spacing(2)};
    padding: ${({ theme: e }) => e.spacing(2)};
    border-radius: ${({ theme: e }) => e.radii.lg};
    border: 2px solid
        ${({ theme: e, $isSelected: t, $ai: n }) => t ? n ? "transparent" : e.colors.primary : e.colors.border};
    background-color: ${({ theme: e, $isSelected: t, $ai: n }) => t && !n ? e.colors.primary + "11" : e.colors.card};
    cursor: ${({ $isDisabled: e }) => e ? "not-allowed" : "pointer"};
    opacity: ${({ $isDisabled: e }) => e ? .5 : 1};
    transition: all ${({ theme: e }) => e.transitions.fast};
    position: relative;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: radial-gradient(circle, currentColor 10%, transparent 10.01%) no-repeat 50%;
        transform: scale(10, 10);
        opacity: 0;
        transition:
            transform 0.5s,
            opacity 1s;
        pointer-events: none;
    }

    &:active::after {
        transform: scale(0, 0);
        opacity: 0.2;
        transition: 0s;
    }

    &:hover {
        border-color: ${({ theme: e, $isSelected: t, $isDisabled: n, $ai: r }) => !n && !t ? e.colors.ring : t ? r ? "transparent" : e.colors.primary : e.colors.border};
        background-color: ${({ theme: e, $isSelected: t, $isDisabled: n, $ai: r }) => !n && !t ? e.colors.accent : t && !r ? e.colors.primary + "11" : e.colors.card};
    }
`, i = e.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme: e, $isSelected: t, $ai: n }) => t && !n ? e.colors.primary : e.colors.mutedForeground};
    flex-shrink: 0;
    min-width: 40px;
    min-height: 40px;
    ${({ $orientation: e }) => e === "vertical" ? "width: 100%;" : "width: 40px; height: 40px;"}
    background-color: ${({ theme: e, $isSelected: t, $ai: n }) => t && !n ? e.colors.primary + "22" : e.colors.muted};
    border-radius: ${({ theme: e }) => e.radii.md};
    overflow: hidden;
    transition: all ${({ theme: e }) => e.transitions.fast};
`, a = e.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`, o = e.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.foreground};
`, s = e.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, c = ({ icon: e, mainText: c, secondaryText: l, isSelected: u = !1, isDisabled: d = !1, ai: f = !1, orientation: p = "horizontal", ...m }) => /* @__PURE__ */ n(r, {
	$isSelected: u,
	$isDisabled: d,
	$hasSecondaryText: !!l,
	$ai: f,
	$orientation: p,
	...m,
	children: [e && /* @__PURE__ */ t(i, {
		$isSelected: u,
		$ai: f,
		$orientation: p,
		children: e
	}), /* @__PURE__ */ n(a, { children: [/* @__PURE__ */ t(o, { children: c }), l && /* @__PURE__ */ t(s, { children: l })] })]
});
//#endregion
export { c as CellMain };
